
const TermsAndCondation = () => {
    return (
        <div className=" mx-auto p-6 rounded-lg shadow-lg">
            <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">
                Terms & Conditions
            </h1>
            <p className="text-center text-sm text-gray-500 mb-8">
                Last Updated: November 21, 2025
            </p>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introduction</h2>
                <p className="text-lg text-gray-700">
                    Welcome to NassFoods. By accessing or using our website and services, you agree to be bound by these Terms & Conditions. Please read them carefully. If you do not agree with any part of these terms, you may not access our platform or use our services.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Use of Our Services</h2>
                <p className="text-lg text-gray-700 mb-4">
                    You agree to use our services only for lawful purposes and in a manner that does not violate any local, national, or international laws.
                </p>
                <ul className="list-disc pl-6 text-lg text-gray-700">
                    <li>You must be at least 18 years old to use our services.</li>
                    <li>You agree not to misuse or attempt to damage our website or systems.</li>
                    <li>You agree to provide accurate information when creating an account or placing orders.</li>
                </ul>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Purchases & Payments</h2>
                <p className="text-lg text-gray-700">
                    All purchases made through our platform must be paid for at the time of order. Prices are subject to change at any time without notice. NassFoods is not responsible for any additional charges, such as transaction or bank fees.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Shipping & Delivery</h2>
                <p className="text-lg text-gray-700">
                    Delivery times may vary based on location and product availability. NassFoods is not responsible for delays caused by external factors such as weather, carrier issues, or inaccurate delivery details provided by customers.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Returns & Refunds</h2>
                <p className="text-lg text-gray-700">
                    Refunds or returns may be granted at the discretion of NassFoods, depending on the nature of the issue. Perishable goods are typically not eligible for return unless they arrive damaged or defective.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Intellectual Property</h2>
                <p className="text-lg text-gray-700">
                    All content on the NassFoods website, including logos, images, text, and designs, is owned by NassFoods and protected by copyright laws. You may not copy, reproduce, or distribute any material without our permission.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Limitation of Liability</h2>
                <p className="text-lg text-gray-700">
                    NassFoods is not responsible for any damages or losses resulting from your use of our website or services. This includes direct, indirect, accidental, or consequential damages.
                </p>
            </section>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Changes to Terms</h2>
                <p className="text-lg text-gray-700">
                    We may update these Terms & Conditions at any time. Any changes will be posted on this page with an updated effective date. Continued use of our services constitutes acceptance of the revised terms.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Contact Us</h2>
                <p className="text-lg text-gray-700">
                    If you have any questions about these Terms & Conditions, feel free to contact us:
                </p>
                <address className="text-lg text-gray-700 mt-4">
                    NassFoods<br />
                    Email: <a href="mailto:support@nassfoods.com" className="text-blue-600">support@nassfoods.com</a><br />
                </address>
            </section>
        </div>
    );
};

export default TermsAndCondation;
